export enum ErrorMessage {
  COMMON_SERVER_ERROR = 'Something went wrong. Please try again or contact Quantuvis customer support.',
  ANOTHER_USER_MIGHT_HAVE_SENT = 'Another user might have sent or is editing this bid.',
  NO_CONNECTION_RELOAD_CONFIRMATION = 'No internet connection found. Please reconnect. ' +
    'Do You want to refresh the page?',
  NO_CONNECTION = 'Your connection was disrupted. Please connect and try again.'
}
